/** Texto de la ficha: SAMP y, al lado, Nombre Cliente de la muestra. */
export function leaveSamplePdfCaption(item = {}) {
  const samp = String(
    item.muestraNombre || (item.idMuestra ? `#${item.idMuestra}` : ""),
  )
    .replace(/\s+/g, " ")
    .trim();
  const cliente = String(item.muestraNombreCliente || "")
    .replace(/\s+/g, " ")
    .trim();
  if (!samp) return cliente;
  if (!cliente || cliente === samp) return samp;
  return `${samp} · ${cliente}`;
}

/** Nombre Cliente de la muestra: el del ítem, o el de una foto ligada. */
export function leaveSampleClienteName(item = {}, photos = []) {
  const direct = String(item.muestraNombreCliente || "")
    .replace(/\s+/g, " ")
    .trim();
  if (direct) return direct;
  const mid = Number(item.idMuestra);
  if (!Number.isFinite(mid) || mid <= 0) return "";
  for (const photo of Array.isArray(photos) ? photos : []) {
    if (Number(photo?.idMuestra) === mid) {
      const name = String(photo.muestraNombreCliente || "")
        .replace(/\s+/g, " ")
        .trim();
      if (name) return name;
    }
    const links = Array.isArray(photo?.linkedMuestras)
      ? photo.linkedMuestras
      : [];
    const hit = links.find((link) => Number(link?.idMuestra) === mid);
    const fromLink = String(hit?.muestraNombreCliente || "")
      .replace(/\s+/g, " ")
      .trim();
    if (fromLink) return fromLink;
  }
  return "";
}

/** Primera página: 6 fotos (3×2). El resto: 8 (4×2). */
export const LEAVE_SAMPLES_FIRST_PAGE = 6;
export const LEAVE_SAMPLES_NEXT_PAGE = 8;

export function leaveSamplePageRows(pageIndex) {
  return pageIndex === 0 ? 3 : 4;
}

/** Reparte el listado: 6 en la primera página y 8 en las siguientes. */
export function chunkLeaveSamplePages(count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  const pages = [];
  let i = 0;
  while (i < n) {
    const size =
      pages.length === 0 ? LEAVE_SAMPLES_FIRST_PAGE : LEAVE_SAMPLES_NEXT_PAGE;
    const countOnPage = Math.min(size, n - i);
    pages.push({ start: i, count: countOnPage });
    i += countOnPage;
  }
  return pages;
}

/** Alto de cada ficha para llenar `rows` filas entre top y bottom. */
export function leaveSampleCardHeight({ top, bottom, rows, gap }) {
  const n = Math.max(1, Number(rows) || 1);
  const g = Math.max(0, Number(gap) || 0);
  const avail = Math.max(0, Number(bottom) - Number(top));
  return (avail - g * (n - 1)) / n;
}
